import {Component, Inject, OnInit} from '@angular/core';
import {GlobalService} from '../../global.service';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {EventsService} from '../../events/events.service';
@Component({
  selector: 'app-event-dialog',
  templateUrl: './event-dialog.component.html',
  styleUrls: ['./event-dialog.component.css']
})
export class EventDialogComponent implements OnInit {
  public type;
  constructor(public eventService: EventsService,public dialog: MatDialog, public globalService: GlobalService, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.type = this.data.type;
  }

  shareYallaAWC(type) {
    if(type=="facebook")
      this.eventService.shareEvent()
    if(type=="twitter"){
      window.location.href = 'https://twitter.com/intent/tweet?text=Check Arabian World Cup Fortnite Tournament Presented by YallaEsports on GBarena now\n https://events.gbarena.com/yalla-arabian-cup/';
    }
    if(type=="whatsapp")
      window.location.href = 'whatsapp://send?text=Check Arabian World Cup Fortnite Tournament Presented by YallaEsports on GBarena now\n https://events.gbarena.com/yalla-arabian-cup/';
  }

  shareEvent(type) {
    if(type=="facebook")
      this.eventService.shareEvent()
    if(type=="twitter"){
      window.location.href = 'https://twitter.com/intent/tweet?text=Shawarmer%20Event%20https://events.gbarena.com/shawarmer/';
    }
    if(type=="whatsapp")
      window.location.href = 'whatsapp://send?text=Shawarmer%20Event%20https://events.gbarena.com/shawarmer/';
  }

  shareFriendZone(type) {
    if(type=="facebook")
      this.eventService.shareEvent()
    if(type=="twitter"){
      window.location.href = 'https://twitter.com/intent/tweet?text=Join now the Friend Zone event on GBarena\n https://events.gbarena.com/friend-zone/';
    }
    if(type=="whatsapp")
      window.location.href = 'whatsapp://send?text=Join now the Friend Zone event on GBarena\n https://events.gbarena.com/friend-zone/';
  }


}
